angular.module('ui.order.orderItemCard.orderItemComments', [
    'ui.order.orderItemCard.orderItemComments.commentRow',
    'ui.order.orderItemCard.orderItemComments.newComment'
])

    .directive('orderItemComments', function () {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/ui/order/orderItemCard/orderItemComments/orderItemComments.html',
            controller: 'OrderItemCommentsController'
        };
    })

    .controller('OrderItemCommentsController', function ($scope, $q, $log, toastr, rest, orderItemCardDataProvider,
                                                         orderItemCommentsControllerUpdatesService,
                                                         usersRepository, ordersRepository) {
        $scope.newComment = null;
        $scope.sendComment = sendComment;
        $scope.isCentreUser = false;

        orderItemCardDataProvider.onDataChange('OrderItemCommentsController', function () {
            initData();
        });

        orderItemCommentsControllerUpdatesService.onNewComment(function () {
            initData();
        });

        function initData() {
            $scope.comments = null;
            var order = orderItemCardDataProvider.getOrder();
            var newOrderId = order ? order.getId() : null;
            if (newOrderId !== $scope.orderId) {
                clearNewComment(); // clear text of new comment only if orderId was changed
            }
            $scope.orderId = newOrderId;
            if (!$scope.orderId) {
                return;
            }

            $q.all([
                usersRepository.getCurrentUser(),
                ordersRepository.getComments($scope.orderId)
            ])
                .then(
                function (data) {
                    var currentUser = data[0];
                    var comments = data[1];
                    $scope.isCentreUser = currentUser.isCentre();
                    $scope.comments = $scope.orderId ? comments : null;
                },
                function (error) {
                    $scope.comments = null;
                    $log.error("Can't load comments for order `%s`. Cause: %s", $scope.orderId, error.message);
                    toastr.error(error.message, "Can't load comments");
                });
        }

        /**
         * Send new comment
         */
        function sendComment() {
            if (!$scope.orderId || !$scope.newComment) {
                return; // error or nothing to show
            }
            var newCommentModel = rest.newModel('CommentModel', _.clone($scope.newComment));
            $scope.newComment = null;

            ordersRepository.saveComment($scope.orderId, newCommentModel)
                .then(function () {
                    clearNewComment();
                    initData();
                }, function (error) {
                    $log.error("Can't add new comment for order `%s`. Cause: %s", $scope.orderId, error.message);
                    toastr.error(error.message, "Can't add comment");
                });
        }

        function clearNewComment() {
            $scope.newComment = {
                text: '',
                customerVisible: false
            };
        }
    })

    // Separate service for update events (to prevent multiple event subscription)
    .service('orderItemCommentsControllerUpdatesService', function (rest) {
        var _this = this;
        var callback;

        rest.events.on("modelCreatedOnServer", function (modelInfo) {
            if (!callback) {
                return;
            }
            if (modelInfo && modelInfo.modelType == "CommentModel") {
                callback(modelInfo);
            }
        });

        _this.onNewComment = function (cb) {
            callback = cb;
        };

        return _this;
    })

;